import { FC, HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

import TButton from "@/components/atoms/buttons/TButton";
import HtmlText from "../common/HtmlText";

import { ITextButton } from "@/components/atoms/buttons/types";

// -----------------------------------------------------------------------------

export type ICtaSquareBox = {
  heading?: string;
  description?: ReactNode;
  button?: ITextButton;
};

export type ICTASquareBoxProps = HTMLAttributes<HTMLDivElement> &
  ICtaSquareBox & {
    variant?: "primary" | "secondary";
  };

const bgColor = {
  primary: "bg-primary-100",
  secondary: "bg-secondary-50",
};

const CTASquareBox: FC<ICTASquareBoxProps> = (props) => {
  const {
    heading,
    description,
    button,
    variant = "primary",
    className,
    ...other
  } = props;

  return (
    <div className={clsx("h-fit", bgColor[variant], className)} {...other}>
      <div className="w-full flex-[1_0_auto] p-4 lg:w-60 xl:w-[276px] xl:p-6">
        {heading && (
          <span className="text-base font-normal text-black-900 lg:text-base xl:text-h6">
            {heading}
          </span>
        )}

        {description && (
          <HtmlText className="my-2 prose-p:!text-sm xl:mb-4 xl:mt-3">
            {description}
          </HtmlText>
        )}

        {button && (
          <TButton
            id={button.id}
            variant={button.variant}
            href={button.link}
            target={button.target}
            radius={button.radius}
          >
            {button.text}
          </TButton>
        )}
      </div>
    </div>
  );
};

export default CTASquareBox;
